<template>
  <div class="organ-tree">
    <div class="input-container">
      <a-input
        v-model.trim="iptVal"
        :class="searchClass"
        :placeholder="$t('common.Search')"
        @blur="searchBlur"
        @focus="searchFocus"
        allowClear
        ref="searchBox"
      >
        <svg-icon slot="prefix" class-name="search" icon-class="search" />
      </a-input>
      <svg-icon
        :hidden="hidden"
        class-name="add-friend"
        :icon-class="iconClass"
        @mouseenter.native="iconClass='add-friend-active'"
        @mouseleave.native="iconClass='add-friend'"
        @click.native="inviteFriendModalVisible = true"
      />
    </div>
    <UserCompanyTree
      :tree-data="filteredTreeData"
      @select="handleSelect"
    />
    <ContactCompanySearch
      :searchVal="searchVal"
      v-if="searchResultVisible"
    />
    <InviteFriendModal v-model="inviteFriendModalVisible"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import InviteFriendModal from '@/components/business/invite-friend-modal/index.vue'
import ContactCompanySearch from '@/components/business/contact-company-search'
import UserCompanyTree from '@/components/business/user-company-tree'
const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('collaborator')

function getParent(data2, nodeId2) {
  var arrRes = []
  if (data2.length === 0) {
    if (nodeId2) {
      arrRes.unshift(data2)
    }
    return arrRes
  }
  const rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      const node = data[i]
      if (node.orgId === nodeId) {
        arrRes.unshift(node)
        rev(data2, node.parentId)
        break
      } else {
        if (node.orgList) {
          rev(node.orgList, nodeId)
        }
      }
    }
    return arrRes
  }
  arrRes = rev(data2, nodeId2)
  return arrRes
}
function getConpanyinfo(list, corpId){
  const c = list.find(i => i.corpId === corpId)
  return {
    companyName: c.name || '',
    companyDesc: c.description || '',
    companyAddr: `${c.province || ''}${c.city === '市辖区' ? '' : c.city}${c.district || ''}${c.address || ''}`
  }
}

export default {
  name: 'OrganTree',
  props: ['setOrganDetail'],
  components: {
    InviteFriendModal,
    ContactCompanySearch,
    UserCompanyTree,
  },
  provide() {
    return {
      selectedKeysContext: {
        func: null
      }
    }
  },
  data() {
    return {
      iconClass: 'add-friend',
      hidden: false,
      searchClass: ['tree-search'],
      searchResultVisible: false,
      inviteFriendModalVisible: false,
    }
  },
  computed: {
    ...mapGetters(['filteredTreeData', 'cropList']),
    ...mapState(['hasLoadTree', 'searchVal']),
    iptVal: {
      get() {
        return this.searchVal
      },
      set(val) {
        if (!val) this.setSearchCropVal(val)
        this.setSearchVal(val)
        this.searchResultVisible = !!val
      }
    }
  },
  methods: {
    ...mapMutations(['setSearchVal', 'setSearchCropVal']),
    ...mapActions(['queryUserInfo', 'getCompanyTree', 'treeData']),
    /**
    * @Param Array selectedKeys [43] ['uid|11006']
    * @Return undefined
    **/
    handleSelect(selectedKeys) {
      if (typeof selectedKeys[0] === 'string') {
        this.queryUserInfo(selectedKeys[0].split('|')[1])
        this.setOrganDetail({ type: 3 })
        return
      }
      if (typeof selectedKeys[0] === 'number') {
        const nodes = getParent(this.filteredTreeData, selectedKeys[0])

        const { companyName, companyDesc, companyAddr } = getConpanyinfo(this.cropList, nodes[0].corpId)

        const middleName = nodes.length === 1 ? '' : nodes[nodes.length - 1].name

        const count = nodes[nodes.length - 1].count || 0

        this.setOrganDetail({
          type: nodes.length === 1 ? 1 : 2,
          companyName,
          companyDesc,
          companyAddr,
          middleName,
          userName: '',
          count
        })
      }
    },
    searchBlur() {
      setTimeout(() => {
        this.searchClass.pop()
        this.hidden = false
        this.searchResultVisible = false
      }, 200)
    },
    searchFocus() {
      this.hidden = true
      this.searchClass.push('active')
      this.searchResultVisible = !!this.iptVal
    }
  },
  created() {
    if (!this.hasLoadTree) {
      this.getCompanyTree()
    }
  }
}
</script>

<style scoped lang="less">
.organ-tree {
  max-height: 100%;
  overflow: auto;
  text-align: left;

  .input-container {
    height: 90px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 32px;
    margin-bottom: 16px;
  }
  .tree-search {
    width: 226px;
    background: #EFF3F8;
    border-radius: 8px;
    transition: all .5s;
    &::v-deep input {
      height: 42px;
      line-height: 42px;
      background: #EFF3F8;
      box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
      border-radius: 8px;
      border-color: transparent;
      border-width: 2px;
      font-size: 16px;
      &:hover,&:focus {
        border-color: #236CFF;
        border-right-width: 2px !important;
      }
      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: #6a6d73;
      }
    }
    .search {
      width: 15px;
      height: 15px;
    }
    ::v-deep .anticon.anticon-close-circle.ant-input-clear-icon {
      font-size: 14px;
    }
  }
  .add-friend {
    width: 42px;
    height: 42px;
    margin-left: 12px;
    cursor: pointer;
    vertical-align: middle;
    transition: .3s;
  }
  .tree-search.active {
    width: 280px;
    ::v-deep .ant-input-prefix {
      display: none;
    }
    ::v-deep input {
      padding-left: 10px;
    }
  }

  ::v-deep .ant-tree li {
    font-size: 16px;
    padding: 0;
    margin: 0;

    &.corp-node {
      padding-left: 27px;
      &>span.ant-tree-switcher:first-child {
        display: none;
      }
      span.ant-tree-title {
        font-weight: bold;
        margin-left: 12px;
      }
    }
    .ant-tree-child-tree {
      span.ant-tree-title {
        font-weight: normal;
      }
    }
    .ant-tree-switcher {
      height: 40px;
      line-height: 40px;
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .ant-tree-node-content-wrapper {
      background: transparent;
      height: 40px;

      .ant-tree-title, .ant-tree-iconEle {
        height: 40px;
        line-height: 40px;
        .svg-icon, img {
          width: 20px;
          height: 20px;
        }
        .svg-icon {
          margin-top: 10px;
        }
      }
    }

    each(range(10), {
      @marginLeft: calc(-18px * @value);
      @paddingLeft: calc(18px * @value);
      .org-node-@{value}, .leaf-node-@{value} {
        margin-left: calc(@marginLeft - 27px);
        padding-left: calc(@paddingLeft + 27px);
      }
      .leaf-node-@{value} {
        margin-bottom: 2px;
      }
      .leaf-node-@{value}.ant-tree-treenode-selected {
        padding-left: calc(@paddingLeft - 4px + 27px);
        margin-right: 0;
        border-left: 4px solid #236cff;
        background: #ebf1ff;
      }
      .leaf-node-@{value}:not(.ant-tree-treenode-selected) {
        margin-left: calc(@marginLeft + 8px - 27px);
        padding-left: calc(@paddingLeft - 8px + 27px);
        margin-right: 8px;

        &:hover {
          background: #F7F8FA;
        }
      }
    })
  }
}

</style>
